// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane.dashboard-pane {
  padding: 1.5rem;
}
.pane.dashboard-pane .dashboard-reservation-status-tile {
  border-bottom: var(--border-elevated);
  color: var(--color-elevated-success);
  font-size: 1.1rem;
  margin-top: -0.95rem;
  margin-left: -1.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
}
.pane.dashboard-pane .dashboard-reservation-status-tile.upcoming {
  color: var(--color-elevated-text);
}
.pane.dashboard-pane .dashboard-reservation-status-tile.active {
  color: var(--color-elevated-success);
}
.pane.dashboard-pane .dashboard-reservation-status-tile.empty {
  color: var(--color-base-text);
}
.pane.dashboard-pane .title {
  border-bottom: var(--border-elevated);
  color: var(--color-base-text);
  font-weight: bold;
  margin-bottom: 0.3rem;
  padding-bottom: 0.3rem;
}
.pane.dashboard-pane .dashboard-section {
  margin-top: 2rem;
}
.pane.dashboard-pane .dashboard-section.dashboard-jobs-tile {
  margin-top: 0;
}
.pane.dashboard-pane .dashboard-jobs-list {
  display: grid;
  grid-template-columns: max-content max-content max-content;
  column-gap: 3rem;
}
.pane.dashboard-pane .dashboard-jobs-list .dashboard-job-item, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: subgrid;
}
.pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.exit-normal .job-name-display, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.exit-normal .job-type-display, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.exit-normal .job-duration-display, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.exit-normal .data-label, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.exit-normal .data-value {
  color: var(--color-elevated-text);
}
.pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.error .job-name-display, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.error .job-type-display, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.error .job-duration-display, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.error .data-label, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.error .data-value {
  color: var(--color-elevated-warn);
}
.pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.error.old .job-name-display, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.error.old .job-type-display, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.error.old .job-duration-display, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.error.old .data-label, .pane.dashboard-pane .dashboard-jobs-list .dashboard-job-card.error.old .data-value {
  color: var(--color-hinting-error-old);
}
.pane.dashboard-pane .dashboard-jobs-list .job-name-display {
  font-size: 0.9rem;
  margin: 0;
}
.pane.dashboard-pane .dashboard-jobs-list .data-label {
  margin-right: 0.5rem;
}
.pane.dashboard-pane .dashboard-jobs-list .job-type-display:after {
  content: "-";
  margin: 0 0.6rem;
}
.pane.dashboard-pane .dashboard-jobs-list .job-last-status-display {
  text-align: right;
}
.pane.dashboard-pane .dashboard-systems-usage-list {
  display: grid;
  grid-template-columns: max-content max-content max-content;
  column-gap: 3rem;
}
.pane.dashboard-pane .dashboard-systems-usage-list .dashboard-system-usage-item, .pane.dashboard-pane .dashboard-systems-usage-list .dashboard-system-usage-card {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: subgrid;
}
.pane.dashboard-pane .dashboard-systems-usage-list .system-identifier {
  margin-right: 0.5rem;
}
.pane.dashboard-pane .dashboard-systems-usage-list .available .dashboard-system-usage-system-identifier {
  color: var(--color-elevated-success);
}
.pane.dashboard-pane .dashboard-systems-usage-list .unavailable .dashboard-system-usage-system-identifier {
  color: var(--color-hinting-error-old);
}
.pane.dashboard-pane .dashboard-quick-links-item {
  margin-top: 0.7rem;
  line-height: 1.2rem;
}
.pane.dashboard-pane svg.icon {
  fill: var(--color-base-draw);
  height: 1.2rem;
  margin-right: 0.7rem;
  top: -0.07rem;
  stroke: var(--color-base-draw);
}`, "",{"version":3,"sources":["webpack://./src/style/panes/dashboard.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,qCAAA;EACA,oCAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,sBAAA;EACA,oBAAA;AACJ;AACI;EACE,iCAAA;AACN;AACI;EACE,oCAAA;AACN;AACI;EACE,6BAAA;AACN;AAGE;EACE,qCAAA;EACA,6BAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAII;EACE,aAAA;AAFN;AAKE;EACE,aAAA;EACA,0DAAA;EACA,gBAAA;AAHJ;AAKI;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;AAHN;AAOM;EACE,iCAAA;AALR;AAUM;EACE,iCAAA;AARR;AAaM;EACE,qCAAA;AAXR;AAeI;EACE,iBAAA;EACA,SAAA;AAbN;AAeI;EACE,oBAAA;AAbN;AAeI;EACE,YAAA;EACA,gBAAA;AAbN;AAeI;EACE,iBAAA;AAbN;AAiBE;EACE,aAAA;EACA,0DAAA;EACA,gBAAA;AAfJ;AAiBI;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;AAfN;AAkBI;EACE,oBAAA;AAhBN;AAmBI;EACE,oCAAA;AAjBN;AAoBI;EACE,qCAAA;AAlBN;AAsBE;EACE,kBAAA;EACA,mBAAA;AApBJ;AAuBE;EACE,4BAAA;EACA,cAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;AArBJ","sourcesContent":[".pane.dashboard-pane {\n  padding: 1.5rem;\n\n  .dashboard-reservation-status-tile {\n    border-bottom: var(--border-elevated);\n    color: var(--color-elevated-success);\n    font-size: 1.1rem;\n    margin-top: -0.95rem;\n    margin-left: -1.5rem;\n    padding-bottom: 0.5rem;\n    padding-left: 1.5rem;\n\n    &.upcoming {\n      color: var(--color-elevated-text);\n    }\n    &.active {\n      color: var(--color-elevated-success);\n    }\n    &.empty {\n      color: var(--color-base-text);\n    }\n  }\n\n  .title {\n    border-bottom: var(--border-elevated);\n    color: var(--color-base-text);\n    font-weight: bold;\n    margin-bottom: 0.3rem;\n    padding-bottom: 0.3rem;\n  }\n\n  .dashboard-section {\n    margin-top: 2rem;\n\n    &.dashboard-jobs-tile {\n      margin-top: 0;\n    }\n  }\n  .dashboard-jobs-list {\n    display: grid;\n    grid-template-columns: max-content max-content max-content;\n    column-gap: 3rem;\n\n    .dashboard-job-item, .dashboard-job-card  {\n      display: grid;\n      grid-column: 1 / -1;\n      grid-template-columns: subgrid;\n    }\n\n    .dashboard-job-card.exit-normal {\n      .job-name-display, .job-type-display, .job-duration-display, .data-label, .data-value {\n        color: var(--color-elevated-text);\n      }\n    }\n\n    .dashboard-job-card.error {\n      .job-name-display, .job-type-display, .job-duration-display, .data-label, .data-value {\n        color: var(--color-elevated-warn);\n      }\n    }\n\n    .dashboard-job-card.error.old {\n      .job-name-display, .job-type-display, .job-duration-display, .data-label, .data-value {\n        color: var(--color-hinting-error-old);\n      }\n    }\n\n    .job-name-display {\n      font-size: 0.9rem;\n      margin: 0;\n    }\n    .data-label {\n      margin-right: 0.5rem;\n    }\n    .job-type-display:after {\n      content: \"-\";\n      margin: 0 0.6rem;\n    }\n    .job-last-status-display  {\n      text-align: right;\n    }\n  }\n\n  .dashboard-systems-usage-list {\n    display: grid;\n    grid-template-columns: max-content max-content max-content;\n    column-gap: 3rem;\n\n    .dashboard-system-usage-item, .dashboard-system-usage-card {\n      display: grid;\n      grid-column: 1 / -1;\n      grid-template-columns: subgrid;\n    }\n\n    .system-identifier {\n      margin-right: 0.5rem;\n    }\n\n    .available .dashboard-system-usage-system-identifier {\n      color: var(--color-elevated-success);\n    }\n\n    .unavailable .dashboard-system-usage-system-identifier {\n      color: var(--color-hinting-error-old);\n    }\n  }\n\n  .dashboard-quick-links-item {\n    margin-top: 0.7rem;\n    line-height: 1.2rem;\n  }\n\n  svg.icon {\n    fill: var(--color-base-draw);\n    height: 1.2rem;\n    margin-right: 0.7rem;\n    top: -0.07rem;\n    stroke: var(--color-base-draw);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
